import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/global';
import { StorageService } from '../../services/storage.service';
import { StorageKeys } from '../../../+enums/storage';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);

  if (req.url.includes(`${environment.baseAPI}`)) {
    const accessToken = storageService.getItem(StorageKeys.TOKEN) || '';

    if (accessToken) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
        },
      });
    }
  }

  return next(req);
};
